import React from 'react';
import { ToggleButton, DisplayText } from '@superops/ui-design-system';
import type { ToggleFieldProps } from '../../types/interface';
import { getTranslatedText } from '@nile/components';
import { DeviceTypeBadges } from '../DeviceTypeBadges';
import { getMarginLeft } from '../../utils/MdmUtils';

const ToggleField = ({
  intl,
  label,
  checked,
  onChange,
  disabled = false,
  level,
  supportedDeviceTypes = [],
  showDeviceTypeBadges = false,
  isParentSectionHovered = false,
  attributeDescription = '',
  isChildAttribute = false,
  minOsVersion
}: ToggleFieldProps) => {
  const shouldShowBadge = showDeviceTypeBadges && supportedDeviceTypes.length > 0;

  return (
    <div
      className={`flex g10 min-h-32 ${getMarginLeft(level)} ${attributeDescription ? 'astart' : 'actr'}`}
    >
      <div className={`${attributeDescription ? 'pt-5' : ''}`}>
        <ToggleButton
          value={checked}
          onChange={onChange}
          locked={disabled}
          size="small"
        />
      </div>
      <div className="flex col">
        <div className="flex g10 min-h-22">
          <DisplayText
            element="p"
            size="large"
            weight="Medium"
          >
            {getTranslatedText(intl, label)}
          </DisplayText>
          <DeviceTypeBadges
            intl={intl}
            supportedDeviceTypes={supportedDeviceTypes}
            shouldShow={shouldShowBadge && isParentSectionHovered}
          />
        </div>
        {attributeDescription && (
          <DisplayText
            element="p"
            size="medium"
            variant="subdued"
          >
            {getTranslatedText(intl, attributeDescription, { minOsVersion })}
          </DisplayText>
        )}
      </div>
    </div>
  );
}

export default ToggleField;
